import { locale } from '@signavio/i18n';
import { userGuideLink } from '../documentationLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const getUserGuideLang = () => {
  let [lang] = locale().split('_');
  if (lang.includes('de')) {
    return 'de';
  }
  return 'en-US';
};
export default function UserGuideLink({
  chapter,
  section,
  children,
  ...rest
}) {
  const lang = getUserGuideLang();
  let url = `${userGuideLink}/`;
  if (!chapter) {
    url = `${url}intro`;
  }
  if (chapter) {
    url = `${url}${chapter}`;
  }
  url = `${url}?locale=${lang}`;
  if (section) {
    url = `${url}#${section}`;
  }
  return /*#__PURE__*/_jsx("a", {
    ...rest,
    href: url,
    rel: "external",
    children: children
  });
}